import React from 'react'
import "assets/css/Dashboard/AnnualConference.css"
import { Link } from "react-router-dom";

const AnnualConference = ({ dashWidgets }) => {
  const bannerUrl = dashWidgets?.data?.upcoming_annual_conference_dashboard_image_url || '';

  return (
    <div className="d-flex flex-column flex-md-column flex-lg-column flex-xl-column flex-sm-column col-xl-4 col-lg-4 col-md-12 col-sm-12 mb-4 gap-md-2 gap-xl-0 gap-lg-0 gap-0" style={{marginTop:"10px"}}>
      <div className="col-md-6 col-lg-12 col-xl-12 col-12 widget overflow-hidden text-center  mb-4">
        <div className="confetti">
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          {bannerUrl && <img className="col-12" src={bannerUrl} style={{objectFit:"cover"}} height="auto" alt="Annual Conference" />}
          <Link to="/annualconference">
            <button className="btn btn-sm bg-gradient-primary text-white mt-3 mb-3">Check Now</button>
          </Link>
        </div>
      </div>

      <div className="col-md-6 col-lg-12 col-xl-12 col-12 widget overflow-hidden "  >
        <p className="text-success-teal strong mt-1" style={{fontSize:"14px"}}>Events & Exhibitions</p>
        <h5 className="font-17 strong mt-4">Share your participation in events & exhibitions</h5>
        <Link to='/exhibitions'>
          <span className="btn btn-sm bg-gradient-primary text-white mt-1">View</span><br />
        </Link>
      </div>
    </div>
  )
}

export default AnnualConference
